import { useAuthStore } from '@/stores/authStore'
import { ROUTES } from '@/router/routeNames'

// Middleware for auth routes - redirects to app if user is already authenticated
export default function guest({ to, next }: any) {
  const authStore = useAuthStore()

  return authStore.getUser()
    .then((user) => {
      // User is authenticated, redirect to appropriate dashboard based on role
      if (to.query.redirect) {
        // If there's a redirect query param, use that
        next({ path: to.query.redirect.toString() })
      } else {
        // Otherwise redirect to the appropriate dashboard based on user role
          next({ name: ROUTES.DASHBOARD })
      }
    })
    .catch(() => {
      // User is not authenticated, proceed to the auth route
      // The route's own redirect logic will handle routing to login
      next()
    })
}
